import React, { Component } from "react"
import { Form, Input, Icon, Button, message } from "antd"
import { observer } from "mobx-react"
import { observable, action } from "mobx"
const FormItem = Form.Item

@observer
export default class extends Component {
  @observable timeLeft = 90
  @observable codeSendable = true
  @observable info = {
    phone: "",
    code: ""
  }

  @action
  changeForm = (e, field) => this.info[field] = e.target.value

  sendVerifyCode = () => {
    this.props.auth.sendVerifyCode(this.info.phone)
      .then(() => {
        this.codeSendable = false
        this.timer = setInterval(() => {
          if (this.timeLeft === 0) {
            clearInterval(this.timer)
            this.codeSendable = true
          } else {
            this.timeLeft -= 1
          }
        }, 1000)
      }, error => {
        message.error(error.message)
      })
  }

  checkVerifyCode = () => {
    const { auth } = this.props

    auth.checkVerifyCode(this.info)
      .then(() => {
        auth.updateFormType("resetPassword")
      }, error => {
        message.error(error.message)
      })
  }

  render() {
    return (
      <section>
        <Form>
          <div>
            <FormItem>
              <Icon type="tablet" />
              <Input size="large"
                placeholder="请输入您的手机号"
                value={this.info.phone} name="phone" onChange={e => this.changeForm(e, "phone")} />
            </FormItem>
            <FormItem>
              <Icon type="message" />
              <Input size="large" placeholder="请输入验证码"
                value={this.info.code} name="code"
                onChange={e => this.changeForm(e, "code")} style={{ width: 160 }} />
              {this.codeSendable ?
                <Button type="primary" className="btn-warning"
                  onClick={this.sendVerifyCode}>发送验证码</Button>
                : <Button disabled>发送成功 {this.timeLeft}s</Button>
              }
            </FormItem>
            <FormItem>
              <Button size="large"
                type="primary" htmlType="submit" onClick={this.checkVerifyCode}>验证</Button>
            </FormItem>
          </div>
        </Form>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/containers/ForgetPassword.js